// item 207 — load the Google Maps JS API (Places library) once, lazily, using the
// referrer-restricted browser key in REACT_APP_GOOGLE_PLACES_API_KEY. Resolves the
// `google.maps.places` namespace, or null when no key is configured or the script fails
// — callers degrade gracefully to plain manual entry.

let loadPromise: Promise<any> | null = null;

export const isPlacesConfigured = (): boolean => !!process.env.REACT_APP_GOOGLE_PLACES_API_KEY;

export const loadGooglePlaces = (): Promise<any> => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return Promise.resolve(null);
  const w = window as any;
  if (w.google?.maps?.places) return Promise.resolve(w.google.maps.places);

  const key = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
  if (!key) return Promise.resolve(null);

  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve) => {
    const finish = () => resolve((window as any).google?.maps?.places ?? null);
    const existing = document.getElementById('google-maps-places') as HTMLScriptElement | null;
    if (existing) {
      existing.addEventListener('load', finish);
      existing.addEventListener('error', () => resolve(null));
      return;
    }
    const script = document.createElement('script');
    script.id = 'google-maps-places';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = finish;
    script.onerror = () => resolve(null);
    document.head.appendChild(script);
  });
  return loadPromise;
};
